import { useInView } from '../hooks/useInView';
import { useCountUp } from '../hooks/useCountUp';

const stats = [
  { value:80, suffix:'%', label:'Improved in confidence', sub:'Problem-solving skills', color:'var(--accent)', decimals:0 },
  { value:56, suffix:'%', label:'More socially sensitive', sub:'To citizen issues', color:'var(--black)', decimals:0 },
  { value:4.72, suffix:'', label:'/ 5 Overall rating', sub:'39 of 54 gave perfect score', color:'var(--accent)', decimals:2 },
  { value:89, suffix:'%', label:'Know themselves better', sub:'Post-workshop self-understanding', color:'var(--black)', decimals:0 },
  { value:94, suffix:'%', label:'Want to continue', sub:'Building on their ideas', color:'var(--accent)', decimals:0 },
];

function Counter({ value, suffix, decimals, active }) {
  const v = useCountUp(value, 1400, active, decimals);
  return <>{decimals > 0 ? v.toFixed(decimals) : Math.round(v)}{suffix}</>;
}

export default function ImpactStats() {
  const [ref, inView] = useInView({ threshold: 0.1 });

  return (
    <section id="impact" className="section-alt">
      <div className="container" ref={ref}>

        <div className={`reveal ${inView?'visible':''}`} style={{ marginBottom:'3.5rem' }}>
          <p className="eyebrow">The Numbers</p>
          <h2 className="h2">Impact at a glance</h2>
          <p className="body-lg" style={{ maxWidth:'520px', marginTop:'0.75rem' }}>
            Real data. Real students. Measured before and after three days of Justice Innovation 101.
          </p>
        </div>

        {/* Big featured stat */}
        <div className={`reveal nb-card-dark ${inView?'visible':''}`} style={{ padding:'3rem', marginBottom:'1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'2rem', transitionDelay:'0.05s' }}>
          <div>
            <div style={{ fontFamily:'var(--font-head)', fontSize:'clamp(4rem,10vw,7rem)', fontWeight:700, color:'var(--accent)', lineHeight:1, letterSpacing:'-0.04em' }}>
              <Counter value={80} suffix="%" decimals={0} active={inView} />
            </div>
            <div style={{ fontFamily:'var(--font-head)', fontSize:'1.1rem', fontWeight:600, color:'var(--white)', marginTop:'0.5rem' }}>of students grew more confident</div>
            <div style={{ fontFamily:'var(--font-body)', fontSize:'0.85rem', color:'#888', marginTop:'0.25rem' }}>in solving real-world problems. The single biggest shift recorded across all metrics.</div>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'1rem', minWidth:'200px' }}>
            {[
              { label:'Before avg', val:'3.0 / 5' },
              { label:'After avg',  val:'4.4 / 5' },
              { label:'Delta',      val:'+1.31' },
            ].map(({ label, val }) => (
              <div key={label} style={{ borderTop:'1px solid #333', paddingTop:'0.75rem' }}>
                <div style={{ fontFamily:'var(--font-head)', fontSize:'0.6rem', fontWeight:700, letterSpacing:'0.15em', textTransform:'uppercase', color:'#666' }}>{label}</div>
                <div style={{ fontFamily:'var(--font-head)', fontSize:'1.3rem', fontWeight:700, color:'var(--white)' }}>{val}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Grid of remaining stats */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:'1.25rem' }}>
          {stats.slice(1).map((s, i) => (
            <div key={i} className={`reveal nb-card ${inView?'visible':''}`} style={{ padding:'2rem 1.75rem', transitionDelay:`${(i+1)*0.08}s` }}>
              <div style={{ fontFamily:'var(--font-head)', fontSize:'clamp(2rem,4vw,3rem)', fontWeight:700, color: i%2===0?'var(--black)':'var(--accent)', lineHeight:1, letterSpacing:'-0.03em', marginBottom:'0.6rem' }}>
                <Counter value={s.value} suffix={s.suffix} decimals={s.decimals} active={inView} />
              </div>
              <div style={{ fontFamily:'var(--font-head)', fontSize:'0.85rem', fontWeight:700, color:'var(--black)', marginBottom:'0.25rem' }}>{s.label}</div>
              <div className="body-sm">{s.sub}</div>
            </div>
          ))}
        </div>

        {/* Skills strip */}
        <div className={`reveal ${inView?'visible':''}`} style={{ marginTop:'1.5rem', transitionDelay:'0.4s' }}>
          <div className="nb-card-surface" style={{ padding:'1.75rem 2rem' }}>
            <div style={{ fontFamily:'var(--font-head)', fontSize:'0.62rem', fontWeight:700, letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--muted)', marginBottom:'1rem' }}>Top skills developed by students</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'0.6rem' }}>
              {[
                ['Fun Learning', 40], ['Problem-Solving', 37], ['Collaboration', 36],
                ['Creative Expression', 35], ['Community Thinking', 33], ['Innovation', 30],
              ].map(([skill, count]) => (
                <span key={skill} className="tag" style={{ background:'var(--white)', borderColor:'var(--black)', display:'flex', alignItems:'center', gap:'6px' }}>
                  {skill}
                  <span style={{ background:'var(--accent)', color:'var(--black)', borderRadius:'2px', padding:'1px 5px', fontSize:'0.6rem', fontWeight:800 }}>{count}</span>
                </span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
